import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

interface NimMediaParams {
  query?: string;
  pageSize?: number;
  pageToken?: string;
  oldestFirst?: boolean;
}

export const nimMediaKeys = {
  all: ['nim', 'media'] as const,
  list: (params: NimMediaParams) => [...nimMediaKeys.all, params] as const,
};

// The signed read URLs the server returns expire after an hour. Cache well
// inside that window so a page restored from cache never renders links that
// have already aged out — a stale item would show as a broken image with no
// explanation. The app-wide default is 5 minutes; this pins it explicitly
// because here it is a correctness bound, not a freshness preference.
const SIGNED_URL_SAFE_CACHE_MS = 10 * 60 * 1000;

export function useNimMedia(params: NimMediaParams = {}) {
  return useQuery({
    queryKey: nimMediaKeys.list(params),
    queryFn: () => adminClient.listNimMedia(params),
    staleTime: SIGNED_URL_SAFE_CACHE_MS,
    gcTime: SIGNED_URL_SAFE_CACHE_MS,
  });
}
